<template>
  <v-app id="root">
    <v-navigation-drawer app v-model="drawer" fixed temporary>
      <v-list-item>
        <v-list-item-content class="text-center">
          <v-list-item-title class="title">
            <img src="@/assets/logo.png" height="200" width="auto" />
          </v-list-item-title>
          <v-list-item-subtitle color="primary">
            v{{ version }}
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-divider></v-divider>
      <v-list dense nav>
        <template v-for="item in items">
          <template
            v-if="
              ((item.role === '*' && user.role !== 'gestor-dispositivos') ||
                item.role === user.role) &&
              item.children
            "
          >
            <v-list-group :prepend-icon="item.icon" :key="item.title">
              <template v-slot:activator>
                <v-list-item-title>{{ item.title }}</v-list-item-title>
              </template>
              <template v-for="(child, i) in item.children">
                <v-list-item
                  v-if="
                    !child.role ||
                    (child.role &&
                      (child.role === '*' || child.role === user.role))
                  "
                  :key="i"
                  :to="item.children[i].path"
                  link
                  color="primary"
                >
                  <v-list-item-icon>
                    <v-icon small>{{ child.icon }}</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ child.title }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </template>
            </v-list-group>
          </template>
          <v-list-item
            v-else-if="
              (item.role === '*' && user.role !== 'gestor-dispositivos') ||
              item.role === user.role
            "
            :key="item.title"
            :to="item.path"
            link
            color="primary"
          >
            <v-list-item-icon>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list>
      <template v-slot:append>
        <div class="pa-2">
          <v-btn
            block
            text
            small
            elevation="0"
            color="primary"
            :loading="loading"
            @click.native="logout()"
          >
            Salir
            <v-icon right dark>mdi-logout</v-icon>
          </v-btn>
        </div>
      </template>
    </v-navigation-drawer>
    <v-app-bar app dark dense color="primary">
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title>Censo MKD</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn text>
        {{ user.name }}
        <v-icon right>mdi-account</v-icon>
      </v-btn>
    </v-app-bar>
    <v-content>
      <v-container fluid>
        <router-view></router-view>
      </v-container>
      <v-snackbar v-model="error" color="error" :timeout="2500" bottom right>
        {{ message }}
      </v-snackbar>
    </v-content>
    <v-footer app> </v-footer>
  </v-app>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import services from "@/utils/services";

export default {
  name: "root",
  data: () => ({
    version: process.env.VUE_APP_VERSION,
    drawer: false,
    loading: false,
    error: false,
    message: "",
    items: [
      { icon: "mdi-home", title: "Home", path: "/home", role: "*" },
      {
        icon: "mdi-account-multiple",
        title: "Usuarios",
        path: "/administracion/usuarios",
        role: "gestor-dispositivos",
      },
      {
        icon: "mdi-settings",
        title: "Administración",
        role: "admin",
        children: [
          {
            icon: "mdi-menu-right",
            title: "Empresas",
            path: "/administracion/empresas",
          },
          {
            icon: "mdi-menu-right",
            title: "Plazas",
            path: "/administracion/plazas",
          },
          {
            icon: "mdi-menu-right",
            title: "Subdirecciones",
            path: "/administracion/subdirecciones",
          },
          {
            icon: "mdi-menu-right",
            title: "Gerencias",
            path: "/administracion/gerencias",
          },
          {
            icon: "mdi-menu-right",
            title: "Tipos de servicio",
            path: "/administracion/tiposservicio",
          },
          {
            icon: "mdi-menu-right",
            title: "Usuarios",
            path: "/administracion/usuarios",
          },
          {
            icon: "mdi-menu-right",
            title: "Configuración Fotos",
            path: "/administracion/configuracion-marca-agua",
          },
        ],
      },
      {
        icon: "mdi-clipboard-text",
        title: "Operación",
        role: "admin",
        children: [
          {
            icon: "mdi-menu-right",
            title: "Preguntas",
            path: "/operacion/preguntas",
          },
          {
            icon: "mdi-menu-right",
            title: "Respuestas",
            path: "/operacion/respuestas",
          },
          {
            icon: "mdi-menu-right",
            title: "Encuestas",
            path: "/operacion/encuestas",
          },
          {
            icon: "mdi-menu-right",
            title: "Tiendas",
            path: "/operacion/tiendas",
          },
          {
            icon: "mdi-menu-right",
            title: "Actividades",
            path: "/operacion/actividades",
          },
          {
            icon: "mdi-menu-right",
            title: "Resultados",
            path: "/operacion/resultados",
          },
          {
            icon: "mdi-menu-right",
            title: "Resultados PDF",
            path: "/operacion/resultadosPDF",
          },
          {
            icon: "mdi-menu-right",
            title: "Temporales",
            path: "/operacion/temporales",
          },
        ],
      },
      {
        icon: "mdi-chart-bar",
        title: "Reportes",
        role: "*",
        children: [
          {
            icon: "mdi-menu-right",
            title: "Tabular de Encuesta",
            path: "/reportes/tabularencuesta",
          },
          {
            icon: "mdi-menu-right",
            title: "Tabular de Encuesta V2",
            path: "/reportes/tabularencuestav2",
          },
          {
            icon: "mdi-menu-right",
            title: "PROMOTORIA PM",
            role: "admin",
            path: "/reportes/tabularencuestaPROMOPM",
          },
          {
            icon: "mdi-menu-right",
            title: "MERCH PM",
            role: "admin",
            path: "/reportes/tabularencuestaMERCHPM",
          },
          {
            icon: "mdi-menu-right",
            title: "Avance por Plaza",
            path: "/reportes/avanceplaza",
          },
          {
            icon: "mdi-menu-right",
            title: "Avance por Usuario",
            path: "/reportes/avanceusuario",
          },
        ],
      },
      {
        icon: "mdi-history",
        title: "Históricos",
        path: "",
        role: "*",
        children: [
          {
            icon: "mdi-menu-right",
            title: "Tabular de Encuesta",
            path: "/historicos/tabularencuesta",
          },
        ],
      },
    ],
  }),
  mounted() {
    this.check();
  },
  computed: {
    ...mapGetters("general", ["user"]),
  },
  methods: {
    ...mapActions("general", ["newUser", "clearData"]),
    check() {
      services.ws("get", "check").then((res) => {
        if (res.ok) {
          this.newUser({ usr_nm: res.data.usr_nm, perfil: res.data.perfil });
        }
      });
    },
    logout() {
      this.loading = true;
      if (this.$session.exists()) {
        let jwt = this.$session.get("jwt");
        let headers = {
          Authorization: "Bearer " + jwt,
        };
        this.axios
          .post(services.routes.logout, null, { headers })
          .then((response) => {
            let res = response.data;
            if (res.correcto) {
              this.$session.destroy();
              this.clearData();
              this.$router.push("/login");
            } else {
              this.error = true;
              this.message = res.mensaje;
            }
          })
          .catch((error) => {
            console.log(error);
            this.error = true;
            this.message =
              "El servicio no se encuentra disponible en estos momentos";
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        this.$router.push("/login");
      }
    },
  },
};
</script>
